import React, { useEffect, useState, forwardRef } from 'react'
import PropTypes from 'prop-types'

const Modal = ({ data, closeButton }, ref) => {
  const [sticky, setSticky] = useState('')

  const handleScroll = () => {
    if (ref.current) {
      const topSpace = 58 + 13
      const {
        top: parentTop,
      } = ref.current.parentElement.getBoundingClientRect()
      const { height } = ref.current.getBoundingClientRect()

      if (
        ref.current.parentElement.scrollHeight +
          parentTop -
          topSpace -
          height <=
        0
      ) {
        setSticky('sticky-end')
      } else if (parentTop < topSpace) {
        setSticky('sticky')
      } else {
        setSticky('')
      }
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    handleScroll()
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <div className={`dhsv_image_ctn_slider_modal ${sticky}`} ref={ref}>
      {closeButton()}
      <div>
        <img className="lazyload" data-src={data.image} />
        <div className="ctn">
          <p className="big red">{data.title}</p>
          <p dangerouslySetInnerHTML={{ __html: data.modalText }} />
        </div>
      </div>
    </div>
  )
}

Modal.propTypes = {
  ref: PropTypes.object,
  data: PropTypes.object,
  closeButton: PropTypes.func,
}

export default forwardRef(Modal)
